import Button, { ButtonProps } from "@mui/material/Button";

interface MyButtonProps extends ButtonProps {}

export default function MyButton({ children, sx, ...rest }: MyButtonProps) {
  return (
    <Button
      variant="contained"
      {...rest}
      sx={{
        backgroundColor: "var(--primary)",
        "&:hover": {
          backgroundColor: "var(--primary)",
        },
        fontFamily: "inherit",
        ...sx,
      }}
    >
      {children}
    </Button>
  );
}
